export const Regexes = {
    // Taken from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    // Taken from https://stackoverflow.com/questions/19105134/regex-for-date-of-birth
    DOB: /((?:0[1-9])|(?:1[0-2]))\/((?:0[0-9])|(?:[1-2][0-9])|(?:3[0-1]))\/(\d{4})/g,
    // Taken from https://stackoverflow.com/a/21456918
    PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{10,}$/,
}

export const Validation = {
    genericRequired: {
        required: 'This field is required',
    },
    password: {
        required: 'Password required',
        minLength: {
            value: 10,
            message: 'Password must be a minimum of 10 characters',
        },
        pattern: {
            value: Regexes.PASSWORD,
            message:
                'Password should have at least 10 characters, one lowercase, one uppercase and one number',
        },
    },
    email: {
        required: 'Email required',
        pattern: {
            value: Regexes.EMAIL,
            message: 'Email is invalid',
        },
    },
    verificationCode: {
        required: 'Verification code required',
    },
    dateOfBirth: {
        required: 'Date of birth required',
        pattern: {
            value: Regexes.DOB,
            message: 'Invalid date of birth format',
        },
    },
    termsAndConditions: {
        required: 'You must accept the terms and conditions',
    },
    notifyEmail: {
        required: 'You must set phone notifications',
    },
    notifyPhone: {
        required: 'You must set phone notifications',
    },
}
